var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        { attrs: { value: _vm.valueMatch ? _vm.value : "" } },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    _vm._l(_vm.options, function(item, index) {
      return _c("el-option", {
        key: index,
        attrs: {
          label: item[_vm.labelField || _vm.valueField],
          value: item[_vm.valueField]
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }